var appUrl_2023 = "https://www.aprilaire.com";

(function ($) {
    $(document).ready(function () {
        disableForms_2023();
        initializeFindAProForm_2023();
        initializeSearchForm_2023();
        initializeNewsletterSubscription_2023();
        initializeFixes_2023();
        initializePhoneActions_2023();
        initializeCart_2023();
        initializeZoomHandler_2023();
        initialize_Consent();
    });

    function initialize_Consent() {
        $(".consent-btn").on("click", function () {
            var revisitWrapper = document.querySelector('.cky-btn-revisit-wrapper');
            if (revisitWrapper) {
                revisitWrapper.click();
            } else {
                console.error('CookieYes revisit wrapper not found.');
            }
        });
    }

    function isFindAProFormDisabled_2023() {
        return false;
    }

    function initializeSearchForm_2023() {
        $(".search-btn").on("click", function () {

            let keyword = "";
            let keywordObj = $(this).parent().find(".txt-search-input");
            if (keywordObj !== null && keywordObj.length > 0) {
                keyword = keywordObj.val();
            }

            var url = appUrl_2023 + "/elastic-search?query=" + keyword;

            window.location.href = url;
        });
    }

    function initializeFindAProForm_2023() {
        $(".form-desktop.find-a-pro-form .green-button").on("click", function () {
            var url = appUrl_2023 + "/find-a-pro";
            var zip = $(this).closest(".form-desktop").find(".form-control").val();
            triggerFindAProSearchWithTracking_2023(zip, "Header Zip", url);
        });

        $(".form-desktop.find-a-pro-form .form-control").keypress(function (e) {
            if (e.which === 13) {
                var url = appUrl_2023 + "/find-a-pro";
                var zip = $(this).val();
                triggerFindAProSearchWithTracking_2023(zip, "Header Zip", url);
            }
        });

        if ($(".find-pro-block").length === 0) return;

        $(".find-pro-block .btn-primary").prop('disabled', isFindAProFormDisabled_2023());

        $('.find-pro-block .service-selector').on('change', function () {
            $(".find-pro-block .btn-primary").prop('disabled', isFindAProFormDisabled_2023());
        });

        $('.find-pro-block .zipcode').on('change', function () {
            $(".find-pro-block .btn-primary").prop('disabled', isFindAProFormDisabled_2023());
        });

        $(".find-pro-block .btn-primary").on("click", function () {
            var url = appUrl_2023 + "/find-a-pro";
            var zip = $(".find-pro-block .zipcode").val();
            var service = $(".find-pro-block .service-selector").val();
            triggerFindAProSearchWithTracking_2023(zip, "Bottom Banner ZIP", url, service);
        });
    }


    function disableForms_2023() {
        $('.top-bar form').attr('onsubmit', 'return false');
        $('.top-bar-wp-new form').attr('onsubmit', 'return false');
        $('.navbar form.d-flex').attr('onsubmit', 'return false');
        $('footer form').attr('onsubmit', 'return false');
        $('.find-pro-block form').attr('onsubmit', 'return false');
    }

    function triggerFindAProSearchWithTracking_2023(zip, location, url, service = null) {

        let destinationUrl = url + "?query=" + zip;
        if (service !== null) {
            destinationUrl += "&professional=" + service;
        }

        if (window.dataLayer) {
            window.dataLayer.push({
                event: "xv-find-pro",
                "xv-find-pro-path": window.location.pathname,
                "xv-find-pro-zip": zip,
                "xv-find-pro-location": location,
                eventCallback: function () {
                    window.location.href = destinationUrl;
                },
                eventTimeout: 1000,
            });
            //workaround in case callback is not happening
            setTimeout(function () {
                window.location.href = destinationUrl;
            }, 2000);
        } else {
            window.location.href = destinationUrl;
        }
    }


    function initializeNewsletterSubscription_2023() {
        $("footer button").click(function () {

            $("footer .error-msg").remove();
            $("footer .success-msg").remove();

            var button = $(this);
            grecaptcha.ready(function () {
                grecaptcha.execute(recaptchaSiteKey, { action: 'newletterregistration' }).then(function (token) {
                    $(button).prop("disabled", true);
                    $.ajax({
                        type: "POST",
                        data: JSON.stringify({
                            Email: $("footer .txt-email").val(),
                            Type: 'locator',
                            Token: token
                        }),
                        url: appUrl_2023 + "/Api/Newsletter/Subscribe",
                        contentType: "application/json;charset=UTF-8"
                    }).done(function (res) {
                        $("footer .txt-email").val("");
                        if ($('footer .success-msg').length === 0) {
                            $("footer form").before("<div class=\"success-msg\">Thank you for subscribing to our newsletter!</div>");
                        }

                        //fb event
                        //try { fbq('track', 'lead', '{content_name: "get-discount-news"}'); } catch (err) { console.log(err); }
                        //pinterest event
                        //try { pintrk('track', 'lead', { lead_type: 'get-discount-news' }); } catch (err) { console.log(err); }
                        //twitter event
                        //try { triggerTwitterEvent('o0kec'); } catch (err) { console.log(err); }

                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        let msgError = "An error occurred while processing your request. Please try again later!";

                        if (jqXHR.status === 409) {
                            msgError = "You are currently subscribed to our newsletter. Keep an eye on your inbox!";
                            $("footer .txt-email").val("");

                            if ($('footer .success-msg').length === 0) {
                                $("footer form").before("<div class=\"success-msg\">" + msgError + "</div>");
                            }
                        }
                        else {
                            if ($('footer .error-msg').length === 0) {
                                $("footer form").before("<div class=\"error-msg\">" + msgError + "</div>");
                            }
                        }

                    }).always(function (res) {
                        $(button).prop("disabled", false);
                    });
                });
            });
        });
    }

    function initializePhoneActions_2023() {
        if (!isMobile_2023()) {

            if ($(".btn-phone").length > 0) {
                $(".btn-phone").attr("href", "javascript:;");
                $(".btn-phone").removeAttr("target");

                $(".btn-phone").on("click", function () {
                    $(".btn-phone").replaceWith('<div class = "phone-number">800-334-6011</div>');
                });
            }
        }


    }


    function initializeFixes_2023() {

        if (isMobile_2023()) {
            $(".navbar-nav .dropdown-toggle").attr("href", "javascript:;");
        }

        $(document).on("click", ".nav-link[href!='javascript:;']", function () {
            location.href = $(this).attr("href");
        });
    }

    function isMobile_2023() {
        return $(window).width() <= 760;
    }

    function initializeCart_2023() {
        let cartCookieName = "cart_total";

        if (getCookie(cartCookieName) === null || getCookie(cartCookieName) === "" || getCookie(cartCookieName) === "0") {
            $(".cart-items").css("visibility", "hidden");
        } else {
            $(".cart-items__number").html(getCookie(cartCookieName));
            $(".cart-items").css("visibility", "visible");
        }
    }

    function getCookie(name) {
        var dc = document.cookie;
        var prefix = name + "=";
        var begin = dc.indexOf("; " + prefix);
        if (begin === -1) {
            begin = dc.indexOf(prefix);
            if (begin !== 0) return null;
        }
        else {
            begin += 2;
            var end = document.cookie.indexOf(";", begin);
            if (end === -1) {
                end = dc.length;
            }
        }
        return decodeURI(dc.substring(begin + prefix.length, end));
    }

    function resizeWindow() {
        if (window.outerWidth / window.innerWidth != 1) {
            $(".zoom-alert-modal").removeClass("hidden");
        }
    }

    function resizeWindowToggleModal() {
        if (window.outerWidth / window.innerWidth != 1) {
            $(".zoom-alert-modal").removeClass("hidden");
        } else if (window.outerWidth / window.innerWidth === 1) {
            $(".zoom-alert-modal").addClass("hidden");
        }
    }

    function initializeZoomHandler_2023() {
        if (!getCookie('zoom_close')) {
            try {
                resizeWindow();
            } catch (error) {
            }
        }

        $(window).on("resize", function () {
            let zoomPercentage = Math.round(window.outerWidth / window.innerWidth * 100);

            if (zoomPercentage >= 110 && zoomPercentage < 125) {
                $("body").addClass('zoom-sm');
            } else {
                $("body").removeClass('zoom-sm');
            }

            if (zoomPercentage >= 125 && zoomPercentage < 150) {
                $("body").addClass('zoom-md');
            } else {
                $("body").removeClass('zoom-md');
            }

            if (!getCookie('zoom_close')) {
                resizeWindowToggleModal();
            }
        });

        $(window).on('load', function () {
            if (window.outerWidth - window.innerWidth === 2) {
                $("body").addClass('zoom-md');
            } else {
                $("body").removeClass('zoom-md');
            }
        });

        $(window).on('DOMContentLoaded', function () {
            if (window.outerWidth - window.innerWidth === 2) {
                $("body").addClass('zoom-md');
            } else {
                $("body").removeClass('zoom-md');
            }
        });

        /*Close dialog modal on click button*/
        $(".close-modal-dialog").on("click", function () {
            setCookie('zoom_close', '1', 30);
            $(".zoom-alert-modal").addClass("hidden");
        });
    }
})(jQuery);

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}